import Icon from 'components/shared/Icon'
import { useSwiper } from 'swiper/react'
import 'swiper/css'
import { StyledTreatmentSliderButton } from './TreatmentSliderButton.styles'

interface TreatmentSliderButtonProps {
    direction: 'prev' | 'next'
}

const TreatmentSliderButton = ({ direction }: TreatmentSliderButtonProps) => {
    const swiper = useSwiper()

    const rotation = direction === 'next' ? -90 : 90

    const handleNavClick = () => {
        direction === 'next' ? swiper.slideNext() : swiper.slidePrev()
    }

    return (
        <StyledTreatmentSliderButton
            direction={direction}
            onClick={handleNavClick}
        >
            <Icon variant="chevron" color="primary_500" rotation={rotation} />
        </StyledTreatmentSliderButton>
    )
}

export default TreatmentSliderButton
